export class SkuIdReq{
    itemSkuId: number
 constructor(itemSkuId:number){
    this.itemSkuId=itemSkuId;
  }
}